import { defaultHttpClient } from 'shared/src/api/httpClient';

export type UploadCoverImageParams = {
  uri: string;
  name?: string;
  type?: string;
  file?: File;
};

export type UploadCoverImageResponse = {
  image: string | null;
};

const UPLOAD_PATH = '/api/v2/like_folder/cover_image/';

/**
 * 웹 전용 구현. picker가 전달한 File 객체를 그대로 multipart FormData 로 전송한다.
 * Content-Type 은 axios 가 boundary 포함해 자동 부여하도록 명시적으로 null 처리한다.
 */
export const uploadCoverImage = async ({ file }: UploadCoverImageParams) => {
  if (file == null) {
    throw new Error('uploadCoverImage(web): file is required');
  }

  const formData = new FormData();
  formData.append('cover_image', file);

  return defaultHttpClient.request<UploadCoverImageResponse>({
    method: 'POST',
    url: UPLOAD_PATH,
    data: formData,
    headers: { 'Content-Type': null },
  });
};
